/**
 * Utility functions for validating external banner link URLs
 */

export interface ValidationResult {
  isValid: boolean;
  error?: string;
}

export function validateRegulatoryLink(url: string): ValidationResult {
  if (!url || url.trim() === '') {
    return {
      isValid: false,
      error: 'URL cannot be empty'
    };
  }

  let parsedUrl: URL;
  try {
    parsedUrl = new URL(url.trim());
  } catch (error) {
    return {
      isValid: false,
      error: 'Invalid URL format. Please enter a complete URL (e.g., https://www.example.com)'
    };
  }

  if (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') {
    return {
      isValid: false,
      error: 'URL must use HTTP or HTTPS protocol'
    };
  }

  const hostname = parsedUrl.hostname.toLowerCase();

  if (hostname.includes('..') || hostname.startsWith('.')) {
    return {
      isValid: false,
      error: 'Invalid domain format detected'
    };
  }

  return {
    isValid: true
  };
}

export function sanitizeRegulatoryLink(url: string): string {
  const trimmed = url.trim();

  if (!/^[a-z][a-z0-9+\-.]*:/i.test(trimmed)) {
    return `https://${trimmed}`;
  }

  return trimmed;
}
